import { render, staticRenderFns } from "./ServiceDesignRow.vue?vue&type=template&id=04d82bba&scoped=true&"
import script from "./ServiceDesignRow.vue?vue&type=script&lang=js&"
export * from "./ServiceDesignRow.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDesignRow.vue?vue&type=style&index=0&id=04d82bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d82bba",
  null
  
)

export default component.exports